import { TOTAL_SUBSCRIPTIONS_ENDPOINT } from '../api-services/ApiEndpoints';

export async function getTotalSubscriptions() {
    const url = `${process.env.REACT_APP_API_URL}${TOTAL_SUBSCRIPTIONS_ENDPOINT}`;
    const token = localStorage.getItem('token');
    
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
        }
    });
    
    if (!response.ok) {
        throw new Error(`Failed to fetch subscription stats: ${response.status}`);
    }
    
    return await response.json();
}